export default "__VITE_ASSET__0fviSqSx__"